export const DOCUMENT_TYPES = 'DOCUMENT_TYPES'
export const DELETE_DOCUMENT_TYPE = 'DELETE_DOCUMENT_TYPE'
export const UPDATE_DOCUMENT_TYPE = 'UPDATE_DOCUMENT_TYPE'
export const ADD_DOCUMENT_TYPE = 'ADD_DOCUMENT_TYPE'
export const ATTACH_OPTIONS = 'ATTACH_OPTIONS'

export const BOOTSTRAP_INVOICE_DOCUMENTTYPES = 'BOOTSTRAP_INVOICE_DOCUMENTTYPES'
export const ATTACHMENTS ='ATTACHMENTS'
export const SET_TOTAL_ATTACHMENTS = 'SET_TOTAL_ATTACHMENTS'
export const DELETE_ATTACHMENT ='DELETE_ATTACHMENT'
export const SET_SELECTED_ATTACHMENTS = 'SET_SELECTED_ATTACHMENTS'
export const SET_SELECT_ALL_STATE ='SET_SELECT_ALL_STATE'


export const PREAPPROVED_INVOICE_ATTACHMENTS = 'PREAPPROVED_INVOICE_ATTACHMENTS'
export const SET_TOTAL_PREAPPROVED_INVOICE_ATTACHMENTS = 'SET_TOTAL_PREAPPROVED_INVOICE_ATTACHMENTS'
export const DELETE_PREAPPROVED_INVOICE_ATTACHMENT = 'DELETE_PREAPPROVED_INVOICE_ATTACHMENT'
export const SET_SELECTED_PREAPPROVED_INVOICE_ATTACHMENTS = 'SET_SELECTED_PREAPPROVED_INVOICE_ATTACHMENTS'
export const SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE = 'SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE'


export const BOOTSTRAP_PREPAYMENT_DOCUMENTTYPES = 'BOOTSTRAP_PREPAYMENT_DOCUMENTTYPES'
export const PREPAYMENT_ATTACHMENTS = 'PREPAYMENT_ATTACHMENTS'
export const SET_TOTAL_PREPAYMENT_ATTACHMENTS = 'SET_TOTAL_PREPAYMENT_ATTACHMENTS'
export const PREPAYMENT_DELETE_ATTACHMENT = 'PREPAYMENT_DELETE_ATTACHMENT'
export const  SET_SELECTED_PREPAYMENT_ATTACHMENTS= 'SET_SELECTED_PREPAYMENT_ATTACHMENTS'
export const SET_SELECT_ALL_PREPAYMENT_STATE = 'SET_SELECT_ALL_PREPAYMENT_STATE'

export const BOOTSTRAP_PROFILE_DOCUMENTTYPES = 'BOOTSTRAP_PROFILE_DOCUMENTTYPES'
export const PROFILE_DOCUMENTS ='PROFILE_DOCUMENTS'

export const PROCESS_DOCUMENTS = 'PROCESS_DOCUMENTS'
export const BOOTSTRAP_PROCESS_DOCUMENTTYPES = 'BOOTSTRAP_PROCESS_DOCUMENTTYPES'

export const BOOTSTRAP_PO_DOCUMENTTYPES = 'BOOTSTRAP_PO_DOCUMENTTYPES'
export const PO_ATTACHMENTS = 'PO_ATTACHMENTS'
export const SET_TOTAL_PO_ATTACHMENTS = 'SET_TOTAL_PO_ATTACHMENTS'
export const PO_DELETE_ATTACHMENT = 'PO_DELETE_ATTACHMENT'
export const SET_SELECTED_PO_ATTACHMENTS = 'SET_SELECTED_PO_ATTACHMENTS'
export const SET_SELECT_ALL_PO_STATE = 'SET_SELECT_ALL_PO_STATE'
